import { VaccineDto } from 'src/dto/vaccine.dto'

export interface TabPanelProps {
  children?: React.ReactNode
  value: number
  index: number
}

export interface VaccineTabsProps {
  vaccines: VaccineDto[]
  search: string
  setSearch: (value: string) => void
  selectedVacines: string[]
  onSelect: (id: string) => void
}

export type VaccineType = 'medicine' | 'vaccine' | 'vermifuge'

export const VACCINE_TYPES = {
  ALL: 'all',
  MEDICINE: 'medicine',
  VACCINE: 'vaccine',
  VERMIFUGE: 'vermifuge'
} as const

export const TAB_LABELS = [
  { label: 'Todos', type: VACCINE_TYPES.ALL },
  { label: 'Medicamentos', type: VACCINE_TYPES.MEDICINE },
  { label: 'Vacinas', type: VACCINE_TYPES.VACCINE },
  { label: 'Vermífugos', type: VACCINE_TYPES.VERMIFUGE }
]
